import { useMemo } from 'react';
import { ORDERS_AUTO_CANCEL } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

export function useIsOrdersAutoCancelEnabled() {
  const tags = useGetTags();
  const isEnabled = useMemo(() => tags.includes(ORDERS_AUTO_CANCEL), [tags]);

  return isEnabled;
}
